import { useMutation, useQueryClient } from '@tanstack/react-query';

import createLead, { LeadResponse } from '@/actions/leads/createLead';
import { CreateLeadPayload } from '@/types/lead.type';
import { ApiResponse } from '@/types/response.type';

export interface UseCreateLeadReturn {
  mutate: (
    payload: CreateLeadPayload
  ) => Promise<ApiResponse<LeadResponse> | undefined>;
  result: ApiResponse<LeadResponse> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useCreateLead = (): UseCreateLeadReturn => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: createLead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['consultant-leads'] });
    },
  });

  return {
    mutate: mutation.mutateAsync,
    result: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isPending,
  };
};
